<div class="header-main bc-mb-5">
    <div class="bc-container">
        <div class="bc-row">
            <div class="bc-col-12">

                <article class="bc-header-wrapper-red">
                    <header class="bc-header">
                        <section class="bc-header-brand">
                            <div>
                                <svg width="94" height="46" viewBox="0 0 94 46" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M25.233 24.3321L18.5072 26.0263V19.4487L24.3295 17.987C25.4672 17.688 26.5714 18.5517 26.5714 19.6812V22.6046C26.5714 23.4351 26.0361 24.1328 25.233 24.3321Z"
                                        fill="#F1F1F1" />
                                    <path
                                        d="M17.1688 32.9362L13.2203 34.0325C12.0826 34.3315 10.9784 33.4678 10.9784 32.3383V29.4148C10.9784 28.6176 11.5137 27.9199 12.3168 27.7206L18.5072 26.0596V31.2752C18.5072 32.0393 17.9718 32.7369 17.1688 32.9362Z"
                                        fill="#F1F1F1" />
                                    <path
                                        d="M18.5072 19.4486L7.73259 22.2724C6.59489 22.5713 5.49066 21.7076 5.49066 20.5449V17.6215C5.49066 16.8242 6.02605 16.1265 6.82912 15.9272L16.2987 13.4689C17.4364 13.1699 18.5407 14.0337 18.5407 15.1632L18.5072 19.4486Z"
                                        fill="#F1F1F1" />
                                    <path
                                        d="M31.7245 32.2387C31.6911 30.1458 31.9587 29.2488 32.628 27.9532C34.0668 28.6176 35.9741 29.2488 37.7811 29.2488C40.1568 29.2488 41.3949 28.4847 41.3949 27.1559C41.3949 26.1593 40.8595 25.4617 38.0153 24.2989C33.8995 22.5383 31.8918 21.3423 31.8918 18.0867C31.8918 14.4324 35.1376 11.9741 39.9895 11.9741C41.8968 11.9741 43.6368 12.3063 45.5107 12.8711C45.5441 14.8975 45.2764 15.8941 44.5738 16.8575C43.1684 16.1599 41.4953 15.728 39.9226 15.728C37.848 15.728 36.7772 16.4921 36.7772 17.6881C36.7772 18.8176 37.5468 19.4487 39.7553 20.2793C44.3395 22.04 46.3138 23.6013 46.3138 26.6576C46.3138 30.6441 43.3022 33.1688 37.6137 33.1688C35.4722 33.1688 33.3976 32.8366 31.7245 32.2387Z"
                                        fill="#F1F1F1" />
                                    <path
                                        d="M63.0446 17.1235L63.0111 31.0097C61.0369 32.3053 57.8246 33.003 55.2145 33.003C51.6007 33.003 48.5557 31.6077 48.5557 27.289V17.8876C49.8942 17.2896 51.4334 17.1235 53.2738 17.1235V26.5914C53.2738 28.2524 54.378 29.0829 56.2853 29.0829C57.0215 29.0829 57.6907 28.9833 58.293 28.8172V17.8544C59.6315 17.2896 61.2376 17.1235 63.0446 17.1235Z"
                                        fill="#F1F1F1" />
                                    <path
                                        d="M72.5142 16.4924V17.1568H77.2322C77.2322 18.1202 76.563 20.0138 75.7265 20.8775H72.5142V32.8037H67.7626V20.8775H65.3868C65.3868 19.5155 66.5245 17.489 67.7626 16.8579V16.0606C67.7626 12.6388 69.603 10.4463 73.9865 10.4463C75.5257 10.4463 77.7342 10.7121 78.4034 10.8449C78.4034 12.6721 78.0688 13.7683 77.3661 14.5656C76.7638 14.4328 75.2915 14.2999 74.7561 14.2999C73.1165 14.2999 72.5142 15.3297 72.5142 16.4924Z"
                                        fill="#F1F1F1" />
                                    <path
                                        d="M80.11 12.3728C80.11 11.0772 81.2142 9.98096 82.5192 9.98096C83.8577 9.98096 84.9619 11.044 84.9619 12.3728C84.9619 13.6684 83.8577 14.7647 82.5192 14.7647C81.2142 14.7979 80.11 13.7349 80.11 12.3728ZM80.1769 17.3227C80.8461 17.0569 81.6492 16.8908 82.5527 16.8908C83.4561 16.8908 84.2592 17.0569 84.895 17.3227V32.8035H80.1434V17.3227H80.1769Z"
                                        fill="#F1F1F1" />
                                </svg>

                            </div>
                            <em class="bc-icon bc-sm bc-icon-mobile">isotipo-bancolombia</em>
                            <div class="bc-header-channel">
                                <h5 aria-label="Sucursal Virtual Inversiones">Facturación Electrónica</h5>
                            </div>
                        </section>
                        <section>
                            <ul class="bc-header-nav">
                                <li class="bc-header-nav-item">
                                    <em class="bc-icon bc-sm" aria-hidden="true">premium</em>
                                    <div>
                                        <p>Bienvenida/o {{ nombre }}</p>
                                    </div>

                                </li>
                                <li class="bc-header-nav-item">
                                    <em (click)="confirmacion()" class="bc-icon bc-sm" aria-hidden="true">quit</em>
                                    <div class="bc-header-nav-item-text">
                                        <p (click)="confirmacion()">Cerrar sesión</p>
                                    </div>

                                </li>
                            </ul>
                        </section>
                    </header>
                </article>

            </div>
        </div>

        <div>
            <bc-modal typeIcon="warning" customWidth="medium" titleAlign="center" [isCancellable]="confirmAction"
                [subTitle]="confirmSubTitle" [buttonAlignment]="confirmButtonAlignment" textBtn="Sí" textBtnLeft="No"
                typeNotify="success" [displayButton]="confirmDisplayButton" [outerCloseTap]="confirmOuterCloseTap"
                (stateClick)="handleModalLogout($event)" #confirmacionlogout>
                <div modalContent>
                </div>
            </bc-modal>
        </div>

    </div>
</div>